module.exports = __webpack_public_path__ + "img/6.a5b2fca.svg";